import * as angular from 'angular';

function filterFunction($filter: ng.IFilterService) {
    var suffixes = ['th', 'st', 'nd', 'rd'];
    return function (input: string) {
        var dtfilter = $filter('date')(input, 'MMMM dd');
        var day = parseInt(dtfilter.slice(-2), 10);
        var relevantDigits = (day < 30) ? day % 20 : day % 30;
        var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
        return suffix;
    };
}

angular
    .module('app.common')
    .filter('dayPrefix', ['$filter', filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/day-prefix.filter.ts